import { render, staticRenderFns } from "./AddressPage.vue?vue&type=template&id=82b04df0&scoped=true&"
import script from "./AddressPage.vue?vue&type=script&lang=js&"
export * from "./AddressPage.vue?vue&type=script&lang=js&"
import style0 from "./AddressPage.vue?vue&type=style&index=0&id=82b04df0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b04df0",
  null
  
)

export default component.exports